export default "__VITE_ASSET__635d485d__"